import { render } from "./MintCoverImage.vue?vue&type=template&id=eb1e7d78&scoped=true"
import script from "./MintCoverImage.vue?vue&type=script&lang=js"
export * from "./MintCoverImage.vue?vue&type=script&lang=js"

import "@/Common/Styles/fileInput.scss?vue&type=style&index=0&id=eb1e7d78&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb1e7d78"]])

export default __exports__